export const GENERIC_CHANNEL_ID = ['genericChannel', 'id'];
export const GENERIC_CHANNEL_NAME = ['genericChannel', 'name'];